import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const MobileNavbar = ({ links, currentPath, toggleMenu }) => {
  return (
    <div className="fixed inset-0 z-40 lg:hidden">
      {/* Background overlay */}
      <motion.div
        className="fixed inset-0 bg-black/70 backdrop-blur-sm"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        onClick={toggleMenu}
      />

      {/* Slide-in Navbar */}
      <motion.div
        className="fixed right-0 top-0 h-full w-64 bg-gray-900 shadow-xl"
        initial={{ x: "100%" }}
        animate={{ x: 0 }}
        exit={{ x: "100%" }}
        transition={{ type: "spring", damping: 25 }}
      >
        <div className="flex h-full flex-col items-center space-y-2 pt-20">
          {links.map((link, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="w-full text-center"
            >
              <Link
                to={link.path}
                onClick={toggleMenu}
                className={`relative block py-2 text-lg text-gray-200 no-underline transition-colors duration-300 ${
                  currentPath === link.path
                    ? "text-green-400 font-medium"
                    : "hover:text-white"
                }`}
              >
                {link.name}
                {currentPath === link.path && (
                  <motion.span
                    className="absolute bottom-2 left-1/4 h-0.5 w-1/2 bg-green-400"
                    layoutId="mobileNavUnderline"
                    transition={{ type: "spring", bounce: 0.25, duration: 0.5 }}
                  />
                )}
              </Link>
            </motion.div>
          ))}

          {/* CTA Button for Mobile */}
          <motion.div
            className="mt-8 w-3/4"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Link
              to="/contact"
              onClick={toggleMenu}
              className="block bg-gradient-to-r from-green-500 to-green-600 text-white font-medium py-3 px-6 rounded-full shadow-lg text-center"
            >
              Get Started
            </Link>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default MobileNavbar;